import { FC } from 'react';
import { observer } from 'mobx-react-lite';

import { TokenLogo } from 'components/TokenLogo/TokenLogo';
import { store } from 'store';
import { TradeEvent } from 'types/event';

import * as S from './EventFeed.styles';

const PROFILE_BASE_URL = 'https://wowmax-polymarket.pages.dev/copy-trading/137';

export interface EventItem {
  id: string;
  wallet: string;
  amount: number;
  type: 'profit' | 'loss';
  tokenSymbol?: string;
  tokenLogo?: string;
}

const formatAmount = (amount: number): string => {
  const sign = amount >= 0 ? '+' : '-';
  return `${sign}$${Math.abs(amount).toLocaleString('en-US', { maximumFractionDigits: 0 })}`;
};

const formatWallet = (wallet: string): string => {
  if (wallet.length <= 10) return wallet;
  return `${wallet.slice(0, 6)}...${wallet.slice(-4)}`;
};

export const EventFeed: FC = observer(() => {
  const { recentEvents } = store.galaxyStore;

  const events: EventItem[] = recentEvents
    .filter((e): e is TradeEvent => 'sell_block' in e)
    .map((e, i) => ({
      id: `${e.sell_block}-${i}`,
      wallet: e.trader.wallet,
      amount: e.amount,
      type: e.type as 'profit' | 'loss',
      tokenSymbol: e.token?.symbol,
      tokenLogo: e.token?.logo_url,
    }));

  const title = 'Live Trades';
  return (
    <S.Container>
      <S.Title>
        <S.LiveDot />
        {title}
      </S.Title>
      <S.List>
        {events.map((event, i) => (
          <S.Item
            key={event.id}
            href={`${PROFILE_BASE_URL}/${event.wallet}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ opacity: 1 - i * 0.08 }}
          >
            <S.ItemContent>
              <S.EventLeft>
                {event.tokenLogo ? (
                  <S.TokenLogoWrapper>
                    <TokenLogo
                      symbol={event.tokenSymbol || ''}
                      logoUrl={event.tokenLogo}
                      size={18}
                    />
                  </S.TokenLogoWrapper>
                ) : (
                  <S.TokenPlaceholder />
                )}
                <S.Wallet>{formatWallet(event.wallet)}</S.Wallet>
              </S.EventLeft>
              <S.EventRight>
                <S.Amount $type={event.type}>{formatAmount(event.amount)}</S.Amount>
              </S.EventRight>
            </S.ItemContent>
          </S.Item>
        ))}
      </S.List>
    </S.Container>
  );
});
